module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_7005.a6088038.png";